import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Card, Input, Modal, Alert, Typography, Spin, Divider, Tag, Space, Form } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import BarCodeScanner from "../../../Comman/Scanner/BarCodeScanner";

const { Title, Text } = Typography;

const BinBulkScan = () => {
  const navigate = useNavigate();
  const [error, setError] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [form] = Form.useForm();

  const handleTagClick = () => {
    setIsModalOpen(true);
  };

  const handleSubmit = (values) => {
    const binId = values.binId;
    if (!binId) {
      setError("Please provide a valid scanned data or enter it manually");
      return;
    }
    try {
      setIsLoading(true);
      navigate(`/dispatch/bulkscan?binId=${encodeURIComponent(binId)}`);
    } catch (error) {
      setError("An error occurred while processing the bin data");
      setIsLoading(false);
    }
  };

  const handleScan = (result) => {
    setIsModalOpen(false);
    handleSubmit({ binId: result });
  };

  const handleScanError = (error) => {
    setError("Error accessing camera. Please try manual input or check camera permissions.");
    console.error(error);
  };

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        <Typography.Title
          level={5}
          style={{
            margin: 0,
          }}
        >
          <ArrowLeftOutlined style={{ paddingRight: 10, }}
            onClick={()=> navigate(`/dispatch/bulkscan`)} />
          Scan to Add Bulk Outward
        </Typography.Title>
      </div>
      <Divider style={{ marginTop: 8 }} />

      <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        <Tag
          style={{ width: "300px", height: "90px", color: "#fff", backgroundColor: "#2db7f5", display: "flex", justifyContent: "center", alignItems: "center", boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.3)", borderRadius: "10px", cursor: "pointer" }}
          onClick={handleTagClick}
        >
          <Text strong style={{ fontSize: "20px", color: "white" }}>SCAN HERE</Text>
        </Tag>

        <Space size="large" style={{ padding: "20px 0" }}>
          <Text strong>OR</Text>
        </Space>

        <Form form={form} layout="vertical" onFinish={handleSubmit} style={{ width: "300px" }}>
          <Form.Item name="binId" label="Enter Bin ID Manually" rules={[{ required: true, message: "Bin ID cannot be empty. Please provide a valid ID." }]}>
            <Input size="large" style={{ textAlign: "center" }} />
          </Form.Item>
          <Form.Item>
            <Button size="large" type="primary" htmlType="submit" block>Submit</Button>
          </Form.Item>
        </Form>
      </div>

      <Modal title="Scan Bar Code" open={isModalOpen} onCancel={() => setIsModalOpen(false)} footer={null}>
        <BarCodeScanner onScan={handleScan} onError={handleScanError} />
      </Modal>
    </>
  );
};

export default BinBulkScan;
